module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Extrabld.ce8da4aba985e28551165eb85bfcba13.woff2";